import cookie from '../../cookie';
import analyticsFactory from '../static/analyticsFactory';

export function dispatchNewEvent(event, detail = null) {
  const triggerEvent = new window.CustomEvent(event, { detail });
  return document.body.dispatchEvent(triggerEvent);
}

export function updateDataLayer(event, data) {
  if (!event || !data) return false;
  if (window.jlData && window.jlData.error) {
    delete window.jlData.error;
  }
  window.jlData = { ...window.jlData, ...data };
  return true;
}

let firstTrigger = true;

function addRecognisedLogin(pageData) {
  const justSignedIn = cookie.getCookie('x-signed-in');
  const shopperId = cookie.getCookie('x-shopper-id');
  if (justSignedIn && shopperId) {
    cookie.deleteCookie('x-signed-in');
    return {
      ...pageData,
      customer: {
        customerInfo: {
          loginStatus: 'recognised login',
          registrationStatus: 'existing registration',
          signinId: shopperId,
        },
      },
    };
  }

  return pageData;
}

export function analyticsTrigger(event, pathname, page, action) {
  const pageData = firstTrigger ? addRecognisedLogin(page) : { ...page };
  const data = analyticsFactory(pathname, pageData);
  updateDataLayer(event, data);
  if (document.readyState === 'complete') {
    dispatchNewEvent(event, action);
  } else {
    document.onreadystatechange = () => {
      if (document.readyState === 'complete') {
        dispatchNewEvent(event, action);
      }
    };
  }
  firstTrigger = false;
}

export default analyticsTrigger;
